import { fetchWithAuth } from '../utils/fetchWithAuth';

export interface MentionUser {
  accountId: string;
  displayName: string;
  avatarUrl?: string;
}

export interface Comment {
  id: string;
  text: string;
  author: string;
  created: string;
  images?: { url?: string; src?: string; filename?: string }[];
}

export const commentsApi = {
  fetchComments: async (issueKey: string): Promise<Comment[]> => {
    const response = await fetchWithAuth(`issues/${encodeURIComponent(issueKey)}/comments`);
    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Failed to fetch comments');
    }

    return data.data.comments || [];
  },

  addComment: async (issueKey: string, text: string, mentions?: MentionUser[]) => {
    const response = await fetchWithAuth(`issues/${encodeURIComponent(issueKey)}/comments`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, mentions: mentions || [] }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Failed to add comment');
    }

    return data;
  },

  searchMentionableUsers: async (issueKey: string, query: string): Promise<MentionUser[]> => {
    const response = await fetchWithAuth(
      `issues/${encodeURIComponent(issueKey)}/mentionable-users?query=${encodeURIComponent(query)}`
    );
    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Failed to search mentionable users');
    }

    return data.data || [];
  },

  deleteComment: async (issueKey: string, commentId: string) => {
    const response = await fetchWithAuth(
      `issues/${encodeURIComponent(issueKey)}/comments/${encodeURIComponent(commentId)}`,
      { method: 'DELETE' }
    );

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.error || 'Failed to delete comment');
    }

    return data;
  },
};
